import { useParams, Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles } from '@/mocks/articles';

export default function ArticleDetail() {
  const { id } = useParams<{ id: string }>();
  const article = articles.find((a) => a.id === Number(id));

  if (!article) {
    return (
      <main className="pt-16">
        <div className="w-full px-4 md:px-6 py-20 text-center">
          <i className="ri-emotion-sad-line text-5xl text-foreground-300 mb-4"></i>
          <h1 className="text-xl font-heading font-bold text-foreground-900 mb-2">文章未找到</h1>
          <p className="text-foreground-500 mb-6">该文章不存在或已被删除</p>
          <Link to="/articles" className="px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-medium cursor-pointer">
            返回文章列表
          </Link>
        </div>
      </main>
    );
  }

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.summary,
    author: {
      '@type': 'Organization',
      name: article.author,
    },
    datePublished: article.date,
    publisher: {
      '@type': 'Organization',
      name: '凌晨不打烊',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(articleSchema)}</script>
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '最新资讯', path: '/articles' },
            { label: article.title },
          ]}
        />

        <article className="w-full px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-3xl mx-auto">
            <div className="mb-8">
              <div className="flex items-center gap-3 text-sm text-foreground-400 mb-4 flex-wrap">
                <span>{article.date}</span>
                <span>·</span>
                <span>{article.readTime}</span>
                <span>·</span>
                <span>{article.author}</span>
              </div>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4 leading-snug">
                {article.title}
              </h1>
              <div className="flex items-center flex-wrap gap-2">
                {article.tags.map((tag) => (
                  <span key={tag} className="px-3 py-1 bg-secondary-100 text-secondary-700 text-xs rounded-full">
                    {tag}
                  </span>
                ))}
              </div>
            </div>

            <div className="mb-8 rounded-xl overflow-hidden">
              <img
                src={article.imageUrl}
                alt={article.title}
                className="w-full h-64 md:h-80 object-cover object-top"
              />
            </div>

            <div
              className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed
                [&_h3]:text-xl [&_h3]:font-heading [&_h3]:font-bold [&_h3]:text-foreground-900 [&_h3]:mt-8 [&_h3]:mb-4
                [&_p]:mb-4 [&_p]:leading-loose
                [&_strong]:text-foreground-900
                [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:mb-4
                [&_li]:mb-1"
              dangerouslySetInnerHTML={{ __html: article.content }}
            />

            <div className="mt-12 pt-8 border-t border-background-200/60">
              <Link
                to="/articles"
                className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i>
                返回文章列表
              </Link>
            </div>
          </div>
        </article>
      </main>
    </>
  );
}